import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';
import Homepage from './pages/Homepage';
import About from './pages/About';
import Layout from './layout/Layout';
import HRService from './pages/HRService';
import ITServices from './pages/ITServices';
import MarketingServices from './pages/MarketingServices';
import ConsultancyServices from './pages/ConsultancyServices';
import ContactPage from './pages/ContactPage';
import DigitalMarketing from './pages/DigitalMarketing';
import MarketResearch from './pages/MarketResearch';
import BrandDevelopment from './pages/BrandDevelopment';
import TraditionalMarket from './pages/TraditionalMarket';
import AdvertisingMedia from './pages/AdvertisingMedia';
import LeadGeneration from './pages/LeadGeneration';
import BusinessDevelopment from './pages/BusinessDevelopment';
import PublicRelation from './pages/PublicRelation';
import CustomerExperience from './pages/CustomerExperience';
import ITStrategy from './pages/ITStrategy';
import SystemIntegration from './pages/SystemIntegration';
import Cybersecurity from './pages/Cybersecurity';
import SoftwareDevelopment from './pages/SoftwareDevelopment';
import DataManagement from './pages/DataManagement';
import ITInfrastructure from './pages/ITInfrastructure';
import ITTraining from './pages/ITTraining';
import RecruitingStaffing from './pages/RecruitingStaffing';
import EmployeeTraining from './pages/EmployeeTraining';
import HRPolicy from './pages/HRPolicy';
import CompesationBenefits from './pages/CompesationBenefits';
import EmployeeRelations from './pages/EmployeeRelations';
import HRConsulting from './pages/HRConsulting';
import HRTechnology from './pages/HRTechnology';
import FinancialPlanning from './pages/FinancialPlanning';
import AccountingBookKeeping from './pages/AccountingBookKeeping';
import Auditing from './pages/Auditing';
import TaxPlanning from './pages/TaxPlanning';
import BudgetingCost from './pages/BudgetingCost';
import CashFlow from './pages/CashFlow';
import FinancialAdvisory from './pages/FinancialAdvisory';
import InternalControls from './pages/InternalControls';
import { initializeFacebookPixel } from './utils/FacebookPixel';


function App() {
  const location = useLocation();

  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  useEffect(() => {
   initializeFacebookPixel();
  }, [location]);

  return (
    <Layout >
      <div className='overflow-hidden bg-white'>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path = '/hr-services' element = {<HRService />} />
          <Route path = '/it-services' element = {<ITServices />} />
          <Route path = '/marketing-services' element = {<MarketingServices />} />
          <Route path = '/finance-services' element = {<ConsultancyServices />} />
          <Route path = '/digital-marketing' element = {<DigitalMarketing />} />
          <Route path = '/market-research' element = {<MarketResearch />} />
          <Route path = '/brand-development' element = {<BrandDevelopment />} />
          <Route path = '/traditional-marketing' element = {<TraditionalMarket />} />
          <Route path = '/advertising-media' element = {<AdvertisingMedia />} />
          <Route path = '/lead-generation' element = {<LeadGeneration />} />
          <Route path = '/business-development' element = {<BusinessDevelopment />} />
          <Route path = '/public-relation' element = {<PublicRelation/>} />
          <Route path = '/customer-experience' element = {<CustomerExperience />} />
          <Route path = '/it-strategy' element = {<ITStrategy />} />
          <Route path = '/system-integration' element = {<SystemIntegration />} />
          <Route path = '/cyber-security' element = {<Cybersecurity />} />
          <Route path = '/software-development' element = {<SoftwareDevelopment />} />
          <Route path = '/data-management' element = {<DataManagement />} />
          <Route path = '/it-infrastructure' element = {<ITInfrastructure />} />
          <Route path = '/it-training' element = {<ITTraining />} />
          <Route path = '/recruitment-staffing' element = {<RecruitingStaffing />} />
          <Route path = '/employee-training' element = {<EmployeeTraining />} />
          <Route path = '/hr-policy' element = {<HRPolicy />} />
          <Route path = '/compensation-benefits' element = {<CompesationBenefits />} />
          <Route path = '/employee-relations' element = {<EmployeeRelations />} />
          <Route path = '/hr-consulting' element = {<HRConsulting />} />
          <Route path = '/hr-technology' element = {<HRTechnology />} />
          <Route path = '/financial-planning' element = {<FinancialPlanning />} />
          <Route path = '/accounting-bookkeeping' element = {<AccountingBookKeeping />} />
          <Route path = '/auditing' element = {<Auditing />} />
          <Route path = '/tax-planning' element = {<TaxPlanning />} />
          <Route path = '/budgeting-cost' element = {<BudgetingCost />} />
          <Route path = '/cash-flow' element = {<CashFlow/>} />
          <Route path = '/financial-advisory' element = {<FinancialAdvisory />} />
          <Route path = '/internal-controls' element = {<InternalControls />} />
        </Routes>
      </div>
    </Layout>
   
  );
}

export default App;
